import React from 'react'
import cx from 'classnames'
import * as R from 'ramda'

import { Icon, InfoIcon } from 'components/shared/Icon/Icon'
import { MessageAlert } from 'components/shared/Alerts/MessageAlert/MessageAlert'

import type { AlertVariant } from 'components/shared/Alert/model'

import styles from './FormFieldHint.module.scss'

type FormFieldHintProps = {
  className?: string
  hint?: React.ReactNode
  hintVariant?: AlertVariant | 'neutral'
}

export const FormFieldHint = ({
  className,
  hint,
  hintVariant = 'neutral',
}: FormFieldHintProps) => {
  if (R.not(hint)) {
    return null
  }

  return hintVariant !== 'neutral' ? (
    <MessageAlert
      message={hint}
      size="small"
      variant={hintVariant}
      isInitialised
    />
  ) : (
    <p className={cx(styles.hint, className)}>
      <Icon className={styles.icon} icon={InfoIcon} size={16} />
      <span className={styles.text}>{hint}</span>
    </p>
  )
}
